export default {
  WITHDRAWAL_AUTOPROCESS_STARTED: 'withdrawal_autoprocess_started',
};
